import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import {
  InstanceResponseDto,
  RegistrationStatus,
  ScenarioResponseDto,
  SnapshotResponseDto,
} from '@cloud-twin-v2/generated/simulation.generated.client';
import { WtrColors } from '@common-modules/shared/styles/wtr-colors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { InstanceUpdatesManagerService } from '../../../../../cloud-twin/src/app/cloud-twin-shared/workers/instance-updates-manager.service';
import { IConnectIndicatorSettings } from '../models/connect-indicator-settings';

const COMPONENT_SELECTOR = 'tc-master-operator-connect-indicator';

@UntilDestroy()
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './master-operator-connect-indicator.component.html',
  styleUrls: ['./master-operator-connect-indicator.component.scss'],
  standalone: false,
})
export class MasterOperatorConnectIndicatorComponent implements OnInit, OnChanges {
  @Input() instance: InstanceResponseDto;
  @Input() snapshot: SnapshotResponseDto;
  @Input() scenario: ScenarioResponseDto;

  // Alternative to instance/snapshot/scenario
  @Input() settings: IConnectIndicatorSettings;

  @Input() isButton = false;

  isConnected: boolean;
  color: WtrColors;
  tooltipKey: string;

  readonly T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;

  constructor(private _instanceUpdatesManagerService: InstanceUpdatesManagerService) {}

  ngOnInit(): void {
    this.checkStatus();

    this.listenStatusChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkStatus();
  }

  private checkStatus(): void {
    let isConnected = true;
    if (this.instance || this.settings) {
      isConnected = isConnected && this.instanceStatus == RegistrationStatus.Online;
    }
    if (this.snapshot || this.settings) {
      isConnected = isConnected && this.snapshotIsDefault;
    }
    if (this.scenario || this.settings) {
      isConnected = isConnected && this.scenarioIsActive;
    }

    this.isConnected = isConnected;
    this.color = this.isConnected ? WtrColors.SuccessColor : WtrColors.ErrorColor;
    this.tooltipKey = `${this.T_SCOPE}.${this.isConnected ? 'connected' : 'disconnected'}`;
  }

  private listenStatusChanges(): void {
    this._instanceUpdatesManagerService.updatedInstance$
      .pipe(
        untilDestroyed(this),
        filter((instance) => {
          return instance.instanceId === this.instanceId;
        })
      )
      .subscribe((updatedInstance) => {
        this.instance = updatedInstance;
        this.checkStatus();
      });
  }

  checkhello(): void {
    console.log('hello');
  }

  private get instanceStatus(): RegistrationStatus | undefined {
    return this.instance?.status ?? this.settings?.instanceStatus;
  }

  private get snapshotIsDefault(): boolean | undefined {
    return this.snapshot?.isDefault ?? this.settings?.snapshotIsDefault;
  }

  private get scenarioIsActive(): boolean | undefined {
    return this.scenario?.isActive ?? this.settings?.scenarioIsActive;
  }

  private get instanceId(): string | undefined {
    return this.instance?.instanceId ?? this.settings?.instanceId;
  }
}
